// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15xZ2","option":"styles_option__2g_ss","active":"styles_active__6_yba"};